// import * as React from 'react';
// import { DataGrid, GridToolbar } from '@mui/x-data-grid';

// export default function User() {
//   const rows = [
//     { id: 1, commodity: 'Gold', broker: 'ABC Brokerage', status: 'Active' },
//     { id: 2, commodity: 'Silver', broker: 'XYZ Brokerage', status: 'Inactive' },
//     { id: 3, commodity: 'Oil', broker: 'DEF Brokerage', status: 'Active' },
//     // Add more rows as needed
//   ];

//   return (
//     <div style={{ height: 300, width: '100%' }}>
//       <DataGrid
//         rows={rows}
//         loading={false}
//         slots={{ toolbar: GridToolbar }}
//         columns={[
//           { field: 'id', headerName: 'ID', width: 90 },
//           { field: 'commodity', headerName: 'Commodity', width: 150 },
//           { field: 'broker', headerName: 'Broker', width: 150 },
//           { field: 'status', headerName: 'Status', width: 120 },
//         ]}
//       />
//     </div>
//   );
// }

import React from 'react';
import { Box } from '@mui/material';
import CustomerMain from './Customers/CustomerMain';
// import './users.css';

const User = () => {
  return (
    <Box sx={{
      // background:'#f0f0f0',
      // padding: '10px'
      
    }}>
      <CustomerMain />
    </Box>
  )
}

export default User

/* eslint-disable */

// import * as React from 'react';
// import PropTypes from 'prop-types';

// import Typography from '@mui/material/Typography';
// import "./users.css"
// import { DataGrid } from '@mui/x-data-grid';

// import Customers from "./Customers";
// import ExtendedPackageUsers from "./ExtendedPackageUsers";
// import { Box, Tab, Tabs } from '@mui/material';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import { DataTable } from 'mui-datatables';
// import "./users.css"

// const theme = createTheme({
//   overrides: {
//     MUIDataTable: {
//       responsiveScroll: {
//         maxHeight: 'none',
//         cursor:"pointer"
//       },
//     },
//   },
// });
// function TabPanel(props) {
//     const { children, value, index, ...other } = props;
  
//     return (
//       <div
//         role="tabpanel"
//         hidden={value !== index}
//         id={`simple-tabpanel-${index}`}
//         aria-labelledby={`simple-tab-${index}`}
//         {...other}
//       >
//         {value === index && (
//           <Box sx={{ p: 3 }}>
//             <Typography>{children}</Typography>
//           </Box>
//         )}
//       </div>
//     );
//   }
  
//   TabPanel.propTypes = {
//     children: PropTypes.node,
//     index: PropTypes.number.isRequired,
//     value: PropTypes.number.isRequired,
//   };
  
//   function a11yProps(index) {
//     return {
//       id: `simple-tab-${index}`,
//       'aria-controls': `simple-tabpanel-${index}`,
//     };
//   }
  
//   export default function BasicTabs() {
//     const [value, setValue] = React.useState(0);
  
//     const handleChange = (event, newValue) => {
//       setValue(newValue);
//     };

//     const rows = [
//       { id: 1, commodity: 'Gold', broker: 'ABC Brokerage', status: 'Active' },
//       { id: 2, commodity: 'Silver', broker: 'XYZ Brokerage', status: 'Inactive' },
//       { id: 3, commodity: 'Oil', broker: 'DEF Brokerage', status: 'Active' },
//       // Add more rows as needed
//     ];
  
  
//     return (
//       <ThemeProvider theme={theme}>
//       <Box sx={{ width: '100%',marginTop:"-60px", padding: "0px" }} >
//         <Box sx={{ borderBottom: 1, borderColor: 'divider', padding: "0px"  }}>
//           <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" >
//             <Tab label="Customers" {...a11yProps(0)} />
//             <Tab label="Extended Package Users" {...a11yProps(1)}  />
           
//           </Tabs>
//         </Box>
//         <TabPanel value={value} index={0} >
//         <Customers  />
//         </TabPanel>
//         <TabPanel value={value} index={1} >
//           <ExtendedPackageUsers />
//         </TabPanel>
       
//       </Box>
//       <div style={{ height: 300, width: '100%', marginTop:10 }}>
//       <DataGrid
//         rows={rows}
//         loading={false}
//         columns={[
//           { field: 'id', headerName: 'ID', width: 90 },
//           { field: 'commodity', headerName: 'Commodity', width: 150 },
//           { field: 'broker', headerName: 'Broker', width: 150 },
//           { field: 'status', headerName: 'Status', width: 120 },
//         ]}
//       />
//     </div>
//       </ThemeProvider>
//     );
//   }
